import r, { useRef as c } from "react";
import { CSSTransition as s } from "react-transition-group";
import t from "./opacityAnimation.module.scss.js";
function p({
  in: o,
  key: m,
  enter: e = 300,
  exit: i = 300,
  children: a
}) {
  const n = c(null);
  return /* @__PURE__ */ r.createElement(
    s,
    {
      key: m,
      in: o,
      nodeRef: n,
      timeout: {
        enter: e,
        exit: i
      },
      style: {
        "--enter": `${e}ms`,
        "--exit": `${i}ms`
      },
      classNames: {
        enter: t.enter,
        enterActive: t.enterActive,
        exit: t.exit,
        exitActive: t.exitActive
      },
      unmountOnExit: !0
    },
    /* @__PURE__ */ r.createElement(
      "div",
      {
        ref: n,
        "data-testid": "opacity-animation"
      },
      a
    )
  );
}
export {
  p as OpacityAnimation
};
//# sourceMappingURL=OpacityAnimation.js.map
